var Config = {
    DEBUG: false,
    LIB_VERSION: '2.71.0'
};

export default Config;
